module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: _vm.cssClasses,
    attrs: {
      "id": _vm.id,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value,
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b29defb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiText.vue
// module id = 283
// module chunks = 2